import { render, staticRenderFns } from "./request-password.vue?vue&type=template&id=d864b2de&scoped=true"
import script from "./request-password.vue?vue&type=script&lang=js"
export * from "./request-password.vue?vue&type=script&lang=js"
import style0 from "./request-password.vue?vue&type=style&index=0&id=d864b2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d864b2de",
  null
  
)

export default component.exports